import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FullCalendarModule} from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { PlaningComponent } from './planing.component';
import { TableauPlaningComponent } from './tableau-planing/tableau-planing.component';
import { CalendarPlaningComponent } from './calendar-planing/calendar-planing.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin
]);

@NgModule({
  declarations: [PlaningComponent, TableauPlaningComponent, CalendarPlaningComponent],
  imports: [
    FullCalendarModule,
    CommonModule
  ],
  exports: [
    PlaningComponent
  ]
})
export class PlaningModule { }
